
import {createSlice} from "@reduxjs/toolkit";

export const profileSearchSlice = createSlice({
    name: 'profileSearchSlc',
    initialState: {value: {
            id: null,
            externalId: null,
            firstName: null,
            lastName: null,
            ssn: null,
            dateOfBirthFrom: null,
            dateOfBirthTo: null,
            minor: null,
            dateOfDeathFrom: null,
            dateOfDeathTo: null,
            livingOrDead: null,
            companyName: null,
            fein: null,
            dateOfDissolutionFrom: null,
            dateOfDissolutionTo: null,
            paymentSystem: null,
            payStatus: null,
            status: null,
            participations: null,
            residuals: null,
            royalties: null
        }},
    reducers:

{
    changeProfileSearch: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeProfileSearch } = profileSearchSlice.actions;

export default  profileSearchSlice.reducer ;
